require('./creditPregrantedLimitVariationStep.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
// @commmons
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @utilities
const { FormattedText, getLanguage, formatText } = require('core/i18n').i18n;
// @helpers
const { getLastNChars } = require('utilities/stringHelper');
const DateHelper = require('utilities/dateHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

class CreditPregrantedLimitVariationStep extends React.Component {

    joinNumberAndAlias(accountAlias, accountNumber) {
        return `${accountAlias} ${accountNumber}`;
    }

    render() {
        const { immCredit, titleKey, subtitleKey, newLimit, immAccount, children, confirmationScriptNone, newFF, keyName } = this.props;
        const formattedAccountNumber = getLastNChars(immCredit.get('iban'), 4, '*', 4);
        const accountAliasAndNumber = this.joinNumberAndAlias(immCredit.get('alias'), formattedAccountNumber);
        const startingDate = DateHelper.formatDate(immCredit.getIn(['details', 'startingDate']));
        const plainAmountObject = getPlainAmountObject({ amount: newLimit, currency: immCredit.getIn(['available', 'currency']) });
        const plainAmountBalanceObject = getPlainAmountObject(immAccount.get('balance'));
        const plainAmountLimitObject = getPlainAmountObject(immCredit.get('limit'));
        const language = getLanguage();
        let newLimitListItem;
        let subtitle;

        if (newLimit !== undefined) {
            newLimitListItem = (
                <OKInformativeListItem title="creditPregrantedLimitVariationStep-newLimit">
                    <div className="credit-pregranted-limit-variation-step__amount">
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    </div>
                </OKInformativeListItem>
            );
        }

        if (subtitleKey) {
            subtitle = (
                <div className="credit-pregranted-limit-variation-step__check-data-subtitle">
                    <FormattedText value={subtitleKey} />
                </div>
            );
        }

        const currentLimit = immCredit.getIn(['limit', 'amount']);
        const operative = formatText((newLimit < currentLimit) ? 'operatives-decreaseLimit' : 'operatives-increaseLmit')

        const content = (
            <article className="credit-pregranted-limit-variation-step">
                <header className="credit-pregranted-limit-variation-step__title">
                    <FormattedText value={titleKey} />
                </header>
                {confirmationScriptNone && newFF &&
                    <div className="block-info-container">
                        <BlockInfo>
                            <FormattedText className="block-info-text" value={'creditPregrantedLimitVariationStep-blockInfo1CC'} injectedStrings={[keyName]} />
                        </BlockInfo>
                    </div>
                }
                {!confirmationScriptNone &&
                    <ContactCenterRender>
                        <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                    </ContactCenterRender>
                }
                <section className="credit-pregranted-limit-variation-step__list-section">
                    {subtitle}
                    <OKInformativeList columns={2}>
                        <OKInformativeListItem
                            title="creditPregrantedLimitVariationStep-accountNumber"
                            bodyText={accountAliasAndNumber}
                        />
                        <OKInformativeListItem
                            title="creditPregrantedLimitVariationStep-bookingDate"
                            bodyText={startingDate}
                        />
                        <OKInformativeListItem
                            title="creditPregrantedLimitVariationStep-accountAmount"
                        >
                            <div className="credit-pregranted-limit-variation-step__amount">
                                <OneLineSymbolAmount
                                    amountObject={plainAmountBalanceObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountBalanceObject, true)} />
                            </div>
                        </OKInformativeListItem>
                        <OKInformativeListItem
                            title="creditPregrantedLimitVariationStep-currentCreditLimit"
                        >
                            <div className="credit-pregranted-limit-variation-step__amount">
                                <OneLineSymbolAmount
                                    amountObject={plainAmountLimitObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountLimitObject, true)} />
                            </div>
                        </OKInformativeListItem>
                        {newLimitListItem}
                    </OKInformativeList>
                </section>
                {confirmationScriptNone && newFF &&
                    <BlockInfo>
                        <p className="requiredReading">
                            <FormattedText value="cc_hireNewCreditCard-requiredReading" />
                        </p>
                        <FormattedText value="creditPregrantedLimitVariationStep-blockInfo2CC" />
                    </BlockInfo>
                }

                {!confirmationScriptNone &&
                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>
                }
                {children}
            </article>
        );

        return content;
    }
}

CreditPregrantedLimitVariationStep.propTypes = {
    immCredit: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    titleKey: PropTypes.string.isRequired,
    subtitleKey: PropTypes.string,
    newLimit: PropTypes.any,
    children: PropTypes.any.isRequired
};

module.exports = CreditPregrantedLimitVariationStep;